module.exports = __webpack_public_path__ + "media/images/global-footer-logo-usc-5ed7059725f7b41d26d1d45b8b4d70e6.png";